import React, { useReducer, useState, useEffect, useContext, useRef } from 'react';
import { useReducerAsync } from 'use-reducer-async';
import { BusinessBillFormDataReducer, businessBillFormDataInitialState } from './BusinessBillFormDataReducer';
import { BusinessAccountBillFormValidationReducer, businessAccountBillValidationInitialState } from './BusinessBillFormValidationReducer';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { Alert, Col, Row, Spinner, Button } from 'react-bootstrap';
import { NewButton as AppButton } from '../../uiwidgets/NewButton';
import { useParams } from 'react-router-dom';
import { getBillById, getAccounts, getAccountTypes, getAccountById } from './BusinessBillsService';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { validateInput } from './BusinessBillValidationService';
import { kickOffFullFormValidation } from 'util/Validators';
import { AsyncBusinessBillDataHandlers } from './BusinessBillFormDataReducer';
import { extractError } from 'api/ErrorUtil';
import { useNavigate } from 'react-router-dom';
import { TenantContext } from 'tenant/TenantContext';
import { formatCurrency } from '../../util/Currency';
import * as XLSX from 'xlsx';
import _ from "lodash";
import { FilesField } from 'uiwidgets/FilesField';



function BusinessBill() {

  const [formData, formDispatchAccountBill] = useReducerAsync(BusinessBillFormDataReducer, businessBillFormDataInitialState, AsyncBusinessBillDataHandlers);
  const [formValidityData, formValidityDispatch] = useReducer(BusinessAccountBillFormValidationReducer, businessAccountBillValidationInitialState)
  const [targetCell, setTargetCell] = useState(null);
  const requestParams = useParams();
  const navigate = useNavigate();
  const { businessConfig } = useContext(TenantContext);
  const [data, setData] = useState([]);
  const [file, setFile] = useState(null);

  const onToastClose = () => {
    formDispatchAccountBill({ type: 'CLEAR_INFO_AND_ERROR' });
  }

  useEffect(() => {
    if (formData.actionType === 'Delete') {
      navigate('/businessbills');
      return;
    }
  }, [formData.actionType]);

  useEffect(() => {
    const fetchAccountsData = async () => {
      try {
        let types = await getAccountTypes();
        let accntsData = await getAccounts();
        formDispatchAccountBill({ type: 'FIELD_EDIT_ACCDATA', payload: { name: 'accountsData', value: { accountTypes: types, accounts: accntsData } } });
      } catch (err) {
        let errors = extractError(err);
        formDispatchAccountBill({ type: 'ERROR', payload: { errors: errors } });
      }
    }
    fetchAccountsData().catch(err => {
      let errors = extractError(err);
      formDispatchAccountBill({ type: 'ERROR', payload: { errors: errors } });
    });
  }, [])

  useEffect(() => {
    const fetchBillById = async (id) => {
      try {
        let bill = await getBillById(id);
        for (let bli of bill.lineItems) {
          bli.lineItemAmount = parseFloat(bli.lineItemAmount) / 100;
        }
        formDispatchAccountBill({ type: "POPULATE_FORM", payload: bill });
      } catch (err) {
        let errors = extractError(err);
        formDispatchAccountBill({ type: 'ERROR', payload: { errors: errors } });
      }
    }

    if (requestParams.billId) {
      const name = 'billId';
      const value = requestParams.billId;
      formDispatchAccountBill({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
      fetchBillById(value).catch((err) => {
        let errors = extractError(err);
        formDispatchAccountBill({ type: "ERROR", payload: { errors: errors } });
      });
    }

  }, [requestParams.billId, formData.accountsData])

  useEffect(() => {
    const fetchAccountById = async (id) => {
      try {
        let account = await getAccountById(id);
        formDispatchAccountBill({ type: "FIELD_EDIT_ACCOUNT", payload: { name: 'account', value: account } });

      } catch (err) {
        let errors = extractError(err);
        formDispatchAccountBill({ type: "ERROR", payload: { errors: errors } });
      }
    }
    if (requestParams.accountId) {
      const name = 'accountId';
      const value = requestParams.accountId;
      formDispatchAccountBill({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
      fetchAccountById(value).catch((err) => {
        let errors = extractError(err);
        formDispatchAccountBill({ type: "ERROR", payload: { errors: errors } });
      });
    }

  }, [requestParams.accountId, formData.accountsData]);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryData = event.target.result;
        const workbook = XLSX.read(binaryData, { type: 'binary' });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        setData(sheetData);
        if (!_.isEmpty(sheetData)) {
          let tempLineItems = [];
          // Iterate through the array using forEach
          sheetData.forEach((obj, index) => {
            tempLineItems.push({
              taxable: obj.taxable,
              lineItemDescription: obj.lineItemDescription,
              lineItemAmount: obj.lineItemAmount,
              quantity: obj.quantity
            })
          });
          formDispatchAccountBill({ type: 'IMPORT_LINE_ITEMS', payload: { lineItems: tempLineItems, salesTaxRate: businessConfig.salesTaxRate } })
        }
      }
      reader.readAsBinaryString(selectedFile);
    }
  };

  const addNewLineItem = (event) => {
    let tempLineItems = formData.lineItems;
    let newElement = {
      lineItemAmount: '',
      lineItemDescription: "",
      taxable: false
    }
    tempLineItems.push(newElement);
    formDispatchAccountBill({ type: 'FIELD_EDIT', payload: { name: 'lineItems', value: tempLineItems } })
  }

  const handleLineItemChange = (kevent) => {
    let objKey = kevent.key;
    formDispatchAccountBill({ type: 'UPDATE_LINE_ITEM', payload: { key: objKey, targetCell: kevent.target } });
    formDispatchAccountBill({ type: 'CALCULATE_AMOUNT_DUE', payload: { salesTaxRate: businessConfig.salesTaxRate } })
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formDispatchAccountBill({ type: 'FIELD_EDIT', payload: { name: name, value: value } })
  }

  const handleValidation = (event) => {
    setTargetCell(event.relatedTarget);
    let dispatchType = 'VALIDATE_' + event.target.name.toUpperCase();
    const name = event.target.name;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    formValidityDispatch({ type: dispatchType, payload: { [name]: value } })

  }

  const updateAccountSuccessFunction = (data) => {
    formDispatchAccountBill({ type: 'FORM_SUBMIT_SUCCESS', payload: data });
  }

  const updateAccountFailureFunction = (data) => {
    formDispatchAccountBill({ type: 'FORM_SUBMIT_FAIL', payload: data })
  }


  const handleSubmit = (event) => {
    let btnText = event.currentTarget.innerText;
    event.preventDefault();

    let formDataEvent = {
      ...event,
      formData: formData,
      formDataIsIsolated: true
    }
    let isFormValid = kickOffFullFormValidation(formDataEvent, formValidityDispatch, validateInput);
    if (!isFormValid) {
      alert("The form still has validation errors!");
      return false;
    }

    let type = (btnText === 'Delete' ? 'Delete' : (btnText === 'Register' ? 'Add' : 'Update'));
    formDispatchAccountBill({
      type: 'FORM_SUBMIT', payload: {
        formData: { ...formData, type: type },
        successFunction: updateAccountSuccessFunction,
        failureFunction: updateAccountFailureFunction
      }
    });
  }

  const deleteBillLineItem = (key) => {
    formDispatchAccountBill({ type: 'REMOVE_LINE_ITEM', payload: { index: key } });
    formDispatchAccountBill({ type: 'CALCULATE_AMOUNT_DUE', payload: { salesTaxRate: businessConfig.salesTaxRate } })
  }


  return (
    <FormContainer
      title={formData.newBill ? 'Add a bill to Account Number: ' + formData.account.number +' for '+formData.accountType?.accountTypeDisplayName
        : 'Edit  Bill: ' + formData.billNumber + " Account Number: "+formData.account?.number
        +' for '+formData.accountType?.accountTypeDisplayName
      }
      submitButtonFunction={handleSubmit}
      errors={formData.errors}
      successmessage={formData.successmessage}
      infoMessage={formData.infoMessage}
      toastCloseFunc={onToastClose}
    >
      <Row>
        <Col>
          <FormField
            name="billDate"
            label="Bill Date"
            type="date"
            readOnly={formData.readOnly}
            value={formData.billDate}
            placeholder="Enter Bill Date"
            onChange={handleChange}
            onBlur={handleValidation}
            valstate={!formValidityData.billDateError} valMsg={formValidityData.billDateErrMsg} />
        </Col>
        <Col>
          <FormField
            name="dueDate"
            label="Due Date"
            type="date"
            readOnly={formData.readOnly}
            value={formData.dueDate}
            placeholder="Enter Due Date"
            onChange={handleChange}
            onBlur={handleValidation}
            valstate={!formValidityData.dueDateError} valMsg={formValidityData.dueDateErrMsg} />
        </Col>
      </Row>
      <Row><Col>
        <FormField
          name="amountDue"
          label="Amount Due"
          type="text"
          value={formData.amountDue / 100}
          placeholder="Enter Amount Due"
          onChange={handleChange}
          onBlur={handleValidation}
          readOnly={true}
          valstate={!formValidityData.amountDueError}
          valMsg={formValidityData.amountDueErrMsg} />
      </Col>
        <Col>
          <Table><tbody>
            <tr>
              <td><label>Recurring Bill</label></td>
              <td>
                <FormField
                  name="recurringBill"
                  type="checkbox"
                  checktype="checkbox"
                  disabled={formData.readOnly}
                  value={formData.recurringBill}
                  checked={formData.recurringBill}
                  onChange={handleChange}
                  onBlur={handleValidation}
                  valstate={!formValidityData.recurringBillError}
                  valMsg={formValidityData.recurringBillErrMsg} />
              </td>
            </tr>
          </tbody></Table>
        </Col>
      </Row>

      <Row><Col>&nbsp;</Col></Row>

      <Row><Col>
        {formValidityData.lineItemsError && <>
          <Alert variant="danger" key="lineitemserrors">{formValidityData.lineItemsErrMsg}</Alert>
        </>}
      </Col></Row>

      <Row>
        <Col>
          <FilesField name="file" placeholder="Import Line Item Data" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            onChange={handleFileChange} />

          <AppButton
            label='Add a Line Item'
            onClick={addNewLineItem}
            disabled={formData.readOnly}
            size='btn-sm' />
        </Col>
      </Row>
      <Row><Col>
        <Table responsive >
          <thead>
            <tr>
              <th width='75'>Taxable</th>
              <th width='350'>Item Description</th>
              <th width='200'>Item Amount</th>
              <th width='75'>Quantity</th>
              <th width='200'>Line Total</th>
              {formData.newBill && <th width='75'>Delete</th>}

            </tr>
          </thead>
          <tbody>
            {formData.lineItems.map((lineItem, key) => {
              let amount = lineItem.lineItemAmount;
              let description = lineItem.lineItemDescription;
              let taxable = lineItem.taxable;
              let quantity = lineItem.quantity;

              let lineItemTotal = taxable ? (parseFloat(amount) * parseFloat(quantity)) * (1 + parseFloat(businessConfig.salesTaxRate)) :
                (parseFloat(amount) * parseFloat(quantity));

              let amountFieldNameIndexed = 'amount_' + key;
              let descriptionFieldNameIndexed = 'description_' + key;
              let taxableFieldNameIndexed = 'taxable_' + key;
              let quantityFieldNameIndexed = 'quantity_' + key;


              let translatedAmountError = `${amountFieldNameIndexed}Error`;
              let errStateAmount = formValidityData[translatedAmountError];
              let translatedAmountErrMsg = `${amountFieldNameIndexed}ErrMsg`;
              let errMessgAmount = formValidityData[translatedAmountErrMsg];

              let translatedDescriptionError = `${descriptionFieldNameIndexed}Error`;
              let errStateDescription = formValidityData[translatedDescriptionError];
              let translatedDescriptionErrMsg = `${descriptionFieldNameIndexed}ErrMsg`;
              let errMessgDescription = formValidityData[translatedDescriptionErrMsg];

              let translatedQuantityError = `${quantityFieldNameIndexed}Error`;
              let errStateQuantity = formValidityData[translatedQuantityError];
              let translatedQuantityErrMsg = `${quantityFieldNameIndexed}ErrMsg`;
              let errMessgQuantity = formValidityData[translatedQuantityErrMsg];

              return (
                <tr key={key}>

                  <td>
                    <FormField
                      name={taxableFieldNameIndexed}
                      type="checkbox"
                      disabled={formData.readOnly}
                      value={taxable}
                      checked={taxable}
                      onChange={(event) => handleLineItemChange({ key, ...event })}
                      onBlur={handleValidation}
                      valstate={!formValidityData.taxableError}
                      valMsg={formValidityData.taxableErrMsg} />
                  </td>
                  <td>
                    <FormField
                      name={descriptionFieldNameIndexed}
                      readOnly={formData.readOnly}
                      type="text"
                      value={description}
                      placeholder="Enter Description"
                      onChange={(event) => handleLineItemChange({ key, ...event })}
                      onBlur={handleValidation}
                      valstate={errStateDescription !== undefined ? !errStateDescription : true}
                      valMsg={errMessgDescription === undefined ? '' : errMessgDescription} />
                  </td>

                  <td>

                    <FormField
                      name={amountFieldNameIndexed}
                      type="text"
                      value={amount}
                      readOnly={formData.readOnly}
                      placeholder="Enter Amount"
                      onChange={(event) => handleLineItemChange({ key, ...event })}
                      onBlur={handleValidation}
                      valstate={errStateAmount !== undefined ? !errStateAmount : true}
                      valMsg={errMessgAmount === undefined ? '' : errMessgAmount} />
                  </td>

                  <td>
                    <FormField
                      name={quantityFieldNameIndexed}
                      type="text"
                      value={quantity}
                      readOnly={formData.readOnly}
                      placeholder="Enter Quantity"
                      onChange={(event) => handleLineItemChange({ key, ...event })}
                      onBlur={handleValidation}
                      valstate={errStateQuantity !== undefined ? !errStateQuantity : true}
                      valMsg={errMessgQuantity === undefined ? '' : errMessgQuantity} />
                  </td>
                  <td>
                    {!isNaN(lineItemTotal) && formatCurrency(lineItemTotal, businessConfig.locale, businessConfig.currency)}
                  </td>
                  {formData.newBill && <td width='75'>
                    <Button variant="dark" className="border-0 text-dark" onClick={(event) => { deleteBillLineItem(key) }} disabled={formData.readOnly}>
                      <FontAwesomeIcon icon={faTrash} />
                    </Button>
                  </td>}


                </tr>
              )
            }
            )
            }
          </tbody>
        </Table>
      </Col>
      </Row>
      <Row>
        <Col>
          {formData.loading === true ?
            (
              <Spinner
                style={{ marginBottom: 27 }}
                animation="border"
                letiant="success"
              />
            )
            :
            <>
              {formData.redirectToEdit && <AppButton label="Edit Newly Created Bill" onClick={(event) => { navigate("/businessbills/" + formData.billId) }} />}
              {!formData.redirectToEdit && formData.newBill && <AppButton label='Register' onClick={(event) => handleSubmit(event)} letiant='info' />}
              {!formData.redirectToEdit && !formData.newBill && <AppButton label='Update' onClick={(event) => handleSubmit(event)} letiant='info' />}
              &nbsp;&nbsp;<AppButton label='Return to Bill List' onClick={(event) => navigate("/businessbills")} />
              {/*Removing delete although it can be allowed as given below
              If bill date is today email, would have gone out and that is why dont allow delete for today. Allow for future dated bill dates 
              {!formData.newBill && isDateGreaterThanToday(formData.billDate) &&<>&nbsp;&nbsp;
              <AppButton label='Delete' onClick={(event) => handleSubmit(event)} letiant='info' /></>}*/}
            </>
          }
        </Col>
      </Row>


    </FormContainer>
  )
}
export default BusinessBill;